import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { device } from '../../../atoms/Utlis/media';

export const GRADIENT =
  'linear-gradient(144.01deg, rgba(255, 201, 81, 0.9) 0%, rgba(206, 86, 176, 0.9) 100%)';

export const Page = styled.div`
  width: 100%;
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;
  font-family: Urbanist, sans-serif;
  background:
    radial-gradient(ellipse 70% 40% at 0% 0%, rgba(201, 77, 170, 0.05), transparent 55%),
    radial-gradient(ellipse 50% 35% at 100% 0%, rgba(255, 201, 81, 0.06), transparent 50%),
    transparent;

  @media ${device.tablet} {
    padding: 16px;
    gap: 16px;
  }
`;

export const Hero = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  padding: 22px 24px;
  background: linear-gradient(
    135deg,
    rgba(255, 201, 81, 0.16) 0%,
    rgba(206, 86, 176, 0.12) 55%,
    rgba(53, 183, 200, 0.08) 100%
  );
  border: 1px solid rgba(201, 77, 170, 0.12);
  box-shadow: 0 8px 28px rgba(201, 77, 170, 0.08);
`;

export const HeroGlow = styled.div`
  pointer-events: none;
  position: absolute;
  top: -80px;
  right: -4%;
  width: 220px;
  height: 220px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 201, 81, 0.32) 0%, transparent 70%);
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const HeroLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
`;

export const BackBtn = styled(Link)`
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(23, 23, 23, 0.7);
  flex-shrink: 0;
  transition: all 0.15s ease;
  &:hover {
    color: #c94daa;
    border-color: rgba(201, 77, 170, 0.25);
    transform: translateX(-2px);
  }
`;

export const HeroText = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeroBadge = styled.span`
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
  padding: 5px 11px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(201, 77, 170, 0.14);
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #c94daa;
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.25;
`;

export const PageSubtitle = styled.p`
  margin: 4px 0 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.65);
  max-width: 600px;
  line-height: 1.45;
`;

export const HeroActions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const RefreshIconButton = styled.button`
  width: 42px;
  height: 42px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  background: #fff;
  color: rgba(23, 23, 23, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    color: #c94daa;
    border-color: rgba(201, 77, 170, 0.3);
  }
`;

export const CreateBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 11px 18px;
  border-radius: 12px;
  border: none;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  background: ${GRADIENT};
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(201, 77, 170, 0.22);
  transition: all 0.15s ease;
  &:hover {
    transform: translateY(-1px);
    opacity: 0.95;
  }
`;

export const StatsStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const StatChip = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid rgba(23, 23, 23, 0.06);
  box-shadow: 0 6px 18px rgba(23, 23, 23, 0.04);
`;

export const StatIcon = styled.div<{ $tone: string }>`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(p) => p.$tone};
  background: ${(p) => `${p.$tone}14`};
  flex-shrink: 0;
`;

export const StatValue = styled.div`
  font-size: 22px;
  font-weight: 800;
  color: #171717;
  line-height: 1.1;
`;

export const StatLabel = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.5);
  margin-top: 2px;
`;

export const ErrorBanner = styled.div`
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(220, 38, 38, 0.08);
  border: 1px solid rgba(220, 38, 38, 0.18);
  color: #dc2626;
  font-size: 14px;
  font-weight: 600;
`;

export const FormAlertBox = styled.div`
  margin: 16px 20px 0;
  padding: 12px 16px;
  border-radius: 12px;
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CreatePanel = styled.div`
  border-radius: 20px;
  background: #fff;
  border: 1px solid rgba(23, 23, 23, 0.08);
  box-shadow: 0 10px 30px rgba(23, 23, 23, 0.05);
  overflow: hidden;
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 20px;
  border-bottom: 1px solid rgba(23, 23, 23, 0.06);
`;

export const PanelTitleRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const PanelTitle = styled.h2`
  margin: 0;
  font-size: 17px;
  font-weight: 800;
  color: #171717;
`;

export const PanelSubtitle = styled.p`
  margin: 3px 0 0;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.5);
`;

export const CloseCreatorBtn = styled.button`
  background: none;
  border: none;
  color: rgba(23, 23, 23, 0.4);
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: all 0.15s ease;
  &:hover {
    color: #171717;
    background: rgba(23, 23, 23, 0.05);
  }
`;

export const CreateBodyGrid = styled.div`
  padding: 20px;
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 24px;
  @media ${device.tablet} {
    grid-template-columns: 1fr;
  }
`;

export const FormColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PreviewColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const LabelRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const Label = styled.label`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: rgba(23, 23, 23, 0.6);
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const FieldHint = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.45);
`;

export const HelperText = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.45);
  margin-top: 2px;
`;

export const CharCounter = styled.span<{ $overLimit?: boolean }>`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: ${(p) => (p.$overLimit ? '#dc2626' : 'rgba(23, 23, 23, 0.45)')};
`;

export const Input = styled.input`
  height: 44px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.12);
  background: #fafafa;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #171717;
  outline: none;
  transition: all 0.15s ease;
  &:focus {
    border-color: rgba(201, 77, 170, 0.5);
    background: #fff;
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
  }
`;

export const FieldGrid2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
`;

export const Select = styled.select`
  height: 44px;
  padding: 0 14px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.12);
  background: #fafafa;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #171717;
  outline: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='14' height='8' viewBox='0 0 14 8' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L7 7L13 1' stroke='%23c94daa' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-position: right 14px center;
  background-repeat: no-repeat;
  padding-right: 36px;
  transition: all 0.15s ease;
  &:focus {
    border-color: rgba(201, 77, 170, 0.5);
    background-color: #fff;
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
  }
`;

export const BodyToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 4px;
  flex-wrap: wrap;
`;

export const InsertVarBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid rgba(201, 77, 170, 0.25);
  background: rgba(201, 77, 170, 0.06);
  color: #c94daa;
  font-family: Urbanist, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    background: rgba(201, 77, 170, 0.12);
  }
`;

export const ToolbarInfo = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: rgba(23, 23, 23, 0.45);
`;

export const TextArea = styled.textarea`
  padding: 12px 14px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.12);
  background: #fafafa;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #171717;
  outline: none;
  resize: vertical;
  line-height: 1.5;
  transition: all 0.15s ease;
  &:focus {
    border-color: rgba(201, 77, 170, 0.5);
    background: #fff;
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
  }
`;

export const SampleValuesSection = styled.div`
  padding: 14px 16px;
  border-radius: 14px;
  background: #fdf4fc;
  border: 1px solid rgba(201, 77, 170, 0.18);
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SectionTitleBar = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

export const InfoIconWrap = styled.div`
  color: #c94daa;
  margin-top: 1px;
`;

export const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 800;
  color: #171717;
`;

export const SectionSubtitle = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.6);
  margin-top: 2px;
`;

export const SampleInputsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  @media ${device.tablet} {
    grid-template-columns: 1fr;
  }
`;

export const SampleField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const SampleLabel = styled.label`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: rgba(23, 23, 23, 0.7);
  strong {
    color: #c94daa;
  }
`;

export const ButtonTypeToggle = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 8px;
`;

export const ButtonTypeOption = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border-radius: 999px;
  border: 1px solid ${({ $active }) => ($active ? "#c94daa" : "rgba(23, 23, 23, 0.12)")};
  background: ${({ $active }) => ($active ? "rgba(201, 77, 170, 0.08)" : "#fff")};
  color: ${({ $active }) => ($active ? "#c94daa" : "#4b5563")};
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: ${({ $active }) => ($active ? "700" : "600")};
  cursor: pointer;
  transition: all 0.15s ease;

  &:hover {
    border-color: #c94daa;
    color: #c94daa;
  }
`;

export const ButtonAddRow = styled.div`
  display: flex;
  gap: 8px;
`;

export const ButtonInputsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.4fr auto;
  gap: 8px;
  align-items: center;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const ButtonHelpBox = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  line-height: 1.4;
  color: #6b7280;
  margin-top: 6px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f9fafb;
  border-left: 3px solid #c94daa;
  display: flex;
  align-items: flex-start;
  gap: 6px;
`;

export const AddButtonBtn = styled.button`
  padding: 0 14px;
  height: 44px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.12);
  background: #fff;
  color: #171717;
  font-family: Urbanist, sans-serif;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;
  &:hover:not(:disabled) {
    background: #f5f5f5;
    border-color: #c94daa;
    color: #c94daa;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ButtonChipsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 6px;
`;

export const ButtonChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 999px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  font-size: 12px;
  font-weight: 700;
  color: #374151;
`;

export const RemoveChipBtn = styled.button`
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;
  &:hover {
    color: #ef4444;
  }
`;

export const FormActions = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 8px;
`;

export const SecondaryBtn = styled.button`
  padding: 0 18px;
  height: 44px;
  border-radius: 12px;
  border: 1px solid rgba(23, 23, 23, 0.14);
  background: #fff;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.7);
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    border-color: rgba(201, 77, 170, 0.3);
    color: #c94daa;
  }
`;

export const PrimaryBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 20px;
  height: 44px;
  border: none;
  border-radius: 12px;
  background: ${GRADIENT};
  color: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 8px 18px rgba(201, 77, 170, 0.22);
  transition: all 0.15s ease;
  &:hover:not(:disabled) {
    transform: translateY(-1px);
    opacity: 0.95;
  }
  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    box-shadow: none;
  }
`;

export const SpinningIcon = styled.span`
  display: inline-flex;
  animation: spin 1s linear infinite;
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;

// ── Phone Mockup Preview ──────────────────────────────────────────────────

export const PreviewContainer = styled.div`
  border-radius: 20px;
  background: #efeae2;
  border: 1px solid rgba(23, 23, 23, 0.1);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 420px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
`;

export const PhoneHeader = styled.div`
  background: #075e54;
  color: #fff;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const PhoneAvatar = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #128c7e;
  color: #fff;
  font-weight: 800;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PhoneTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
`;

export const PhoneStatus = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.75);
`;

export const PhoneChatArea = styled.div`
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 10px;
  background-image: radial-gradient(rgba(0, 0, 0, 0.04) 1px, transparent 1px);
  background-size: 16px 16px;
`;

export const ChatBubble = styled.div`
  align-self: flex-start;
  max-width: 90%;
  background: #ffffff;
  border-radius: 12px;
  border-top-left-radius: 3px;
  padding: 10px 12px 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const ChatBody = styled.div`
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #111b21;
  line-height: 1.45;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const PlaceholderText = styled.span`
  color: #9ca3af;
  font-style: italic;
`;

export const ChatFooter = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: #667781;
  border-top: 1px dashed rgba(0, 0, 0, 0.08);
  padding-top: 4px;
`;

export const ChatMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  color: #667781;
`;

export const DoubleCheckMark = styled.span`
  color: #53bdeb;
  font-size: 11px;
  font-weight: 700;
`;

export const PreviewButtonsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 90%;
`;

export const PreviewButtonPill = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 8px 12px;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  color: #00a884;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;

export const PreviewFooterNote = styled.div`
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.85);
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
`;

// ── List Section ─────────────────────────────────────────────────────────

export const ListPanel = styled.div`
  border-radius: 20px;
  background: #fff;
  border: 1px solid rgba(23, 23, 23, 0.08);
  box-shadow: 0 8px 24px rgba(23, 23, 23, 0.04);
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const SearchFilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const SearchBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 38px;
  padding: 0 12px;
  border-radius: 10px;
  background: #fafafa;
  border: 1px solid rgba(23, 23, 23, 0.1);
  min-width: 240px;
`;

export const SearchInput = styled.input`
  border: none;
  background: transparent;
  outline: none;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #171717;
  width: 100%;
  &::placeholder {
    color: #9ca3af;
  }
`;

export const ClearSearchBtn = styled.button`
  background: none;
  border: none;
  color: #9ca3af;
  cursor: pointer;
  padding: 2px;
  display: flex;
  align-items: center;
`;

export const FilterTabs = styled.div`
  display: flex;
  gap: 6px;
  background: #f3f4f6;
  padding: 3px;
  border-radius: 10px;
`;

export const FilterTabBtn = styled.button<{ $active?: boolean }>`
  padding: 6px 12px;
  border-radius: 8px;
  border: none;
  background: ${(p) => (p.$active ? '#fff' : 'transparent')};
  color: ${(p) => (p.$active ? '#171717' : '#6b7280')};
  font-family: Urbanist, sans-serif;
  font-size: 12px;
  font-weight: ${(p) => (p.$active ? '700' : '600')};
  cursor: pointer;
  box-shadow: ${(p) => (p.$active ? '0 2px 6px rgba(0,0,0,0.06)' : 'none')};
  transition: all 0.15s ease;
`;

export const ListBody = styled.div`
  padding: 20px;
`;

export const EmptyWrap = styled.div`
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TemplateListGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  align-items: stretch;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const TemplateCard = styled.div<{ $isApproved?: boolean }>`
  padding: 16px;
  border-radius: 16px;
  background: #fafafa;
  border: 1px solid ${(p) => (p.$isApproved ? 'rgba(34, 197, 94, 0.25)' : 'rgba(23, 23, 23, 0.08)')};
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 100%;
  box-sizing: border-box;
  transition: all 0.15s ease;
  &:hover {
    background: #fff;
    border-color: rgba(201, 77, 170, 0.25);
    box-shadow: 0 8px 24px rgba(201, 77, 170, 0.08);
  }
`;

export const TemplateTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
`;

export const TemplateHeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TemplateDisplayName = styled.div`
  font-size: 15px;
  font-weight: 800;
  color: #171717;
  word-break: break-all;
`;

export const PillsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const CategoryBadge = styled.span<{ $category: string }>`
  padding: 3px 8px;
  border-radius: 999px;
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  background: ${(p) =>
    p.$category === 'UTILITY'
      ? 'rgba(59, 130, 246, 0.1)'
      : p.$category === 'AUTHENTICATION'
      ? 'rgba(245, 158, 11, 0.1)'
      : 'rgba(201, 77, 170, 0.1)'};
  color: ${(p) =>
    p.$category === 'UTILITY'
      ? '#2563eb'
      : p.$category === 'AUTHENTICATION'
      ? '#d97706'
      : '#c94daa'};
`;

export const LanguageBadge = styled.span`
  padding: 3px 8px;
  border-radius: 999px;
  background: #f3f4f6;
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  font-weight: 700;
  color: #4b5563;
`;

export const StatusBadge = styled.span<{ $status: string }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  font-weight: 700;
  padding: 5px 10px;
  border-radius: 999px;
  text-transform: capitalize;
  flex-shrink: 0;
  background: ${(p) => {
    const s = (p.$status || '').toLowerCase();
    if (s === 'approved') return 'rgba(34, 197, 94, 0.12)';
    if (s === 'rejected') return 'rgba(239, 68, 68, 0.12)';
    return 'rgba(245, 158, 11, 0.14)';
  }};
  color: ${(p) => {
    const s = (p.$status || '').toLowerCase();
    if (s === 'approved') return '#16a34a';
    if (s === 'rejected') return '#dc2626';
    return '#d97706';
  }};
`;

export const TemplatePurposeBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  background: #f3f4f6;
  border-left: 3px solid #c94daa;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: #4b5563;
  line-height: 1.35;
  word-break: break-word;
`;

export const TemplatePurposeText = styled.span`
  strong {
    color: #111827;
    font-weight: 700;
  }
`;

export const TemplateBodyBox = styled.div`
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  line-height: 1.45;
  background: #fff;
  border: 1px solid rgba(23, 23, 23, 0.05);
  border-radius: 10px;
  padding: 10px 12px;
  white-space: pre-wrap;
  word-break: break-word;
`;

export const TemplateFooterBox = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: #6b7280;
  font-style: italic;
`;

export const TemplateButtonsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
`;

export const MiniButtonChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  border-radius: 6px;
  background: #f3f4f6;
  font-size: 11px;
  font-weight: 700;
  color: #2563eb;
`;

export const TemplateActionsBar = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: auto;
  padding-top: 10px;
  border-top: 1px solid rgba(23, 23, 23, 0.06);
  flex-wrap: nowrap;
  width: 100%;
`;

export const ActionBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 9px;
  border-radius: 8px;
  border: 1px solid rgba(23, 23, 23, 0.12);
  background: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: #374151;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.15s ease;
  &:hover:not(:disabled) {
    color: #c94daa;
    border-color: rgba(201, 77, 170, 0.3);
    background: #fdf4fc;
  }
  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
  .spin-animation {
    animation: spin 1s linear infinite;
  }
`;

export const DeleteActionBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 9px;
  border-radius: 8px;
  border: 1px solid rgba(220, 38, 38, 0.15);
  background: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: #dc2626;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  transition: all 0.15s ease;
  &:hover:not(:disabled) {
    background: #fef2f2;
    border-color: #dc2626;
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LaunchCampaignShortcutBtn = styled.button`
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 6px 10px;
  border-radius: 8px;
  border: none;
  background: ${GRADIENT};
  color: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  box-shadow: 0 3px 8px rgba(201, 77, 170, 0.22);
  transition: all 0.15s ease;
  &:hover {
    transform: translateY(-1px);
    opacity: 0.95;
  }
`;

// ── Modal Components ─────────────────────────────────────────────────────

export const ModalBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const ModalBox = styled.div`
  width: 100%;
  max-width: 440px;
  border-radius: 20px;
  background: #fff;
  padding: 24px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ModalHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ModalHeading = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 800;
  color: #171717;
`;

export const ModalText = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.7);
  line-height: 1.5;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  color: #4b5563;
  line-height: 1.4;
  input {
    margin-top: 2px;
  }
`;

export const ModalBtnRow = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 6px;
`;

export const DeleteConfirmBtn = styled.button`
  padding: 0 16px;
  height: 42px;
  border-radius: 10px;
  border: none;
  background: #dc2626;
  color: #fff;
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
  &:hover {
    background: #b91c1c;
  }
`;
